import { Button, Card, CardContent, CardHeader, Grid } from '@material-ui/core';
import { CustomerClient, isValidWithoutData } from 'clients';
import clsx from 'clsx';
import { useAuth } from 'context';
import { useModal } from 'hooks';
import { useTranslation } from 'next-i18next';
import { NotifyUtils } from 'utils';
import DeleteAddressModal from '../DeleteAddressModal';
import styles from './styles.module.css';

const CardComp = ({
  isSelect,
  address,
  handleOnSelect,
  handleReloadData,
  handleEdit,
  selectAddressCode,
}) => {
  const { t: translateAlertAction } = useTranslation('alert-action');
  const { t: translateMyAccount } = useTranslation('myAccount');

  const { name = '', phone = '', isDefault = false, masterAddress = '', code = '' } = address;
  const {
    user: { customerID },
  } = useAuth();
  const [open, toggle] = useModal();

  const handleDelete = async () => {
    try {
      const result = await CustomerClient.deleteAddress({ code, customerID });
      if (!isValidWithoutData(result))
        throw Error(result?.message || translateAlertAction('message_delete_address_fail'));
      NotifyUtils.success(translateAlertAction('message_delete_address_success'));
      handleReloadData();
    } catch (error) {
      NotifyUtils.error(translateAlertAction(error.message));
    }
  };

  const handleSetDefault = async () => {
    try {
      const result = await CustomerClient.updateAddressDefault({ code, customerID });
      if (!isValidWithoutData(result))
        throw Error(
          result?.message || translateAlertAction('message_failed_update_default_address'),
        );
      NotifyUtils.success(translateAlertAction('message_update_default_address'));
      handleReloadData();
    } catch (error) {
      NotifyUtils.error(translateAlertAction(error.message));
    }
  };

  return (
    <Grid item xs={12} md={6}>
      <Card
        className={
          isSelect && selectAddressCode === address.code
            ? clsx(styles.card_selected, styles.card)
            : styles.card
        }
        data-test="card-address"
      >
        <CardHeader
          action={
            isDefault ? (
              <div className={styles.default_tag}> {translateMyAccount('default')}</div>
            ) : (
              <></>
            )
          }
          title={name}
          subheader={`${translateMyAccount('phone_number')}: ${phone}`}
        />
        <CardContent>
          <div className={styles.float_bottom}>
            <div>
              <div className={styles.ellipsis_2_line}>
                <b> {translateMyAccount('address')}: </b> {masterAddress}
              </div>
            </div>

            <div className={styles.group_button}>
              {isSelect && (
                <Button
                  variant="contained"
                  className={clsx(styles.action_button, styles.important_action_button)}
                  onClick={() => {
                    handleOnSelect(address);
                  }}
                  data-test="btn-select-address"
                >
                  {translateMyAccount('deliver_to_this_address')}
                </Button>
              )}
              <Button
                variant="outlined"
                className={
                  isSelect
                    ? clsx(styles.action_button, styles.defaull_button)
                    : clsx(styles.action_button, styles.important_action_button)
                }
                onClick={() => handleEdit(address)}
              >
                {translateMyAccount('edit')}
              </Button>
              {!isDefault && !isSelect && (
                <Button
                  variant="outlined"
                  className={clsx(styles.action_button, styles.defaull_button)}
                  onClick={handleSetDefault}
                >
                  {translateMyAccount('default')}
                </Button>
              )}
              {!isDefault && (
                <Button
                  variant="outlined"
                  className={styles.action_button}
                  onClick={toggle}
                  data-test="btn-delete-address-card"
                >
                  {translateMyAccount('remove')}
                </Button>
              )}
            </div>
          </div>
        </CardContent>
      </Card>
      <DeleteAddressModal visible={open} onClose={toggle} onClickOk={handleDelete} />
    </Grid>
  );
};

export default CardComp;
